/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ai_Import_Settings_Skip_LabelInputs */



/**
* | output |
* | --- |
* | "Don't ask again" |
*
* @param {Ai_Import_Settings_Skip_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const ai_import_settings_skip_label = /** @type {((inputs?: Ai_Import_Settings_Skip_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ai_Import_Settings_Skip_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Ne plus demander")
	if (locale === "de") return /** @type {LocalizedString} */ ("Nicht mehr fragen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Non chiedere più")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Больше не спрашивать")
	if (locale === "es") return /** @type {LocalizedString} */ ("No volver a preguntar")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("不再询问")
	if (locale === "ja") return /** @type {LocalizedString} */ ("今後表示しない")
	if (locale === "hi") return /** @type {LocalizedString} */ ("दोबारा न पूछें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Não perguntar novamente")
	return /** @type {LocalizedString} */ ("Don't ask again")
});